import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apollo, QueryRef } from 'apollo-angular';

@Injectable({
    providedIn: 'root'
})
export class EcapGql {
    constructor(private apollo: Apollo) {}

    watchQuery<T, V = EmptyObject>(options: Apollo.WatchQueryOptions<T, V>): QueryRef<T, V> {
        return this.apollo.watchQuery(options);
    }

    mutate<T, V = EmptyObject>(options: Apollo.MutateOptions<T, V>): Observable<Apollo.MutateResult<T>> {
        return this.apollo.use('Mutations').mutate(options);
    }

    watchQueryCache<T, V = EmptyObject>(options: Apollo.WatchQueryOptions<T, V>): QueryRef<T, V> {
        return this.apollo.use('QueryCache').watchQuery(options);
    }

    mutateCache<T, V = EmptyObject>(options: Apollo.MutateOptions<T, V>): Observable<Apollo.MutateResult<T>> {
        return this.apollo.use('MutationsCache').mutate(options);
    }
}

export type EmptyObject = {
    [key: string]: any;
};
